<main class="middle-content">
    <div class="content-section">
        <ol class="breadcrumb custom-breadcrumb">
            <li class="breadcrumb-item active">
                <a routerLink="/subadmin-mgt">Patient Management </a>
            </li>
            <li class="breadcrumb-item">Add</li>
        </ol>
        <div class="order-view mt30 max-WT-700 mrgn-0-auto">
            <form [formGroup]="addSubAdminForm">
                <div class="main-block-innner mb40 mt40">
                    <div class="add-store-block input-style">

                        <!-- **********************Subadmin profile image ****************  -->

                        <div class="text-center mt-4 mb-5">
                            <div class="flex-block align-center">
                                <div class="profile_block" style="position: relative">
                                    <img [src]="imageUrl || 'assets/img/profile-img.jpg'" class="imagePicture"
                                        alt="Patient image" (error)="onImageError($event)" />
                                    <br>
                                    <span class="camera">
                                        <i class="fa fa-camera" style="display:flex; ">
                                            <input type="file" class="cameraInput"
                                                accept="image/jpg,image/jpeg,image/png" id="file" formControlName='file'
                                                (change)="ValidateFileUpload($event)">
                                        </i>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-4">
                                <h6> First Name :</h6>
                            </label>
                            <div class="col-md-8">
                                <input type="text" class="form-control" placeholder="First name"
                                    [formControl]="addSubAdminForm.controls['firstName']" maxlength="256"
                                    (keypress)="inputkeyPress($event)" minlength="2">
                                @if((addSubAdminForm.controls['firstName'].dirty ||
                                addSubAdminForm.controls['firstName'].touched) &&
                                addSubAdminForm.controls['firstName'].invalid){
                                <div class="error-block">
                                    @if(addSubAdminForm.controls['firstName'].hasError('required')){
                                    <span style='color:red'
                                        [ngClass]="{error:addSubAdminForm.controls['firstName'].hasError('required')}">*Please
                                        enter user first name.</span>
                                    }

                                    @if(addSubAdminForm.controls['firstName'].hasError('pattern')){
                                    <span style='color:red'
                                        [ngClass]="{error: addSubAdminForm.controls['firstName'].hasError('pattern')}">*First
                                        name
                                        should be characters only.</span>
                                    }


                                    @if(addSubAdminForm.controls['firstName'].hasError('maxlength') && !
                                    addSubAdminForm.controls['firstName'].hasError('pattern')){
                                    <span style='color:red'
                                        [ngClass]="{error: addSubAdminForm.controls['firstName'].hasError('maxlength') && addSubAdminForm.controls['firstName'].dirty}">
                                        *First name should be maximum 256 characters.
                                    </span>
                                    }

                                    @if(addSubAdminForm.controls['firstName'].hasError('minlength') && !
                                    addSubAdminForm.controls['firstName'].hasError('pattern')){
                                    <span style='color:red'
                                        [ngClass]="{error: addSubAdminForm.controls['firstName'].hasError('minlength') && addSubAdminForm.controls['firstName'].dirty}">
                                        *First name should be at least 2 characters.
                                    </span>
                                    }
                                </div>
                                }
                            </div>
                        </div>

                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-4">
                                <h6> Last Name :</h6>
                            </label>
                            <div class="col-md-8">
                                <input type="text" class="form-control" placeholder="Last name"
                                    [formControl]="addSubAdminForm.controls['lastName']" maxlength="256"
                                    (keypress)="inputkeyPress($event)" minlength="2">
                            </div>
                        </div>


                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-4">
                                <h6> Email :</h6>
                            </label>
                            <div class="col-md-8">
                                <input type="email" class="form-control" placeholder="Email"
                                    (keypress)="passwordKeyPress($event)"
                                    [formControl]="addSubAdminForm.controls['email']" maxlength="50">
                                @if(addSubAdminForm.controls['email'].dirty &&
                                addSubAdminForm.controls['email'].invalid){
                                <div class="error-block">
                                    @if(addSubAdminForm.controls['email'].hasError('required')){
                                    <span style='color:red'
                                        [ngClass]="{error:addSubAdminForm.controls['email'].hasError('required')}">
                                        *Please enter an email.
                                    </span>
                                    }
                                    @if(addSubAdminForm.controls['email'].hasError('pattern')){
                                    <span style='color:red'
                                        [ngClass]="{error: addSubAdminForm.controls['email'].hasError('pattern')}">
                                        *Please enter valid email.
                                    </span>
                                    }
                                    @if(addSubAdminForm.controls['email'].hasError('maxlength') && !
                                    addSubAdminForm.controls['email'].hasError('pattern')){
                                    <span style='color:red'
                                        [ngClass]="{error: addSubAdminForm.controls['email'].hasError('maxlength') && addSubAdminForm.controls['email'].dirty}">
                                        *Please enter valid email.
                                    </span>
                                    }

                                </div>
                                }
                            </div>
                        </div>
                        <div class="form-group row align-items-baseline mb-3">
                            <label class="col-md-4">
                                <h6>Phone Number : </h6>
                            </label>
                            <div class="col-md-3">
                                <select name="patient" style="padding: 0 40px" formControlName="phoneCode"
                                    class="custom-select form-control" id="inputGroupSelect01"
                                    aria-labelledby="dropdownMenuButton">
                                    <!-- <option value="">Dial Code</option> -->
                                    @for (data of countryArr; track data; let i = $index) {
                                    <option [value]="data.phone_code">
                                        {{data.phone_code}} &nbsp; {{data.name}}</option>
                                    }
                                </select>
                            </div>
                            <div class="col-md-5">
                                <input type="tel" class="form-control" placeholder="Phone Number"
                                    (keypress)="inputKeyPress($event)"
                                    [formControl]="addSubAdminForm.controls['phoneNumber']" maxlength="20">
                                @if(addSubAdminForm.controls['phoneNumber'].dirty &&
                                addSubAdminForm.controls['phoneNumber'].invalid){
                                <div class="error-block text-nowrap">
                                    @if(addSubAdminForm.controls['phoneNumber'].hasError('required')){
                                    <span style='color:red'
                                        [ngClass]="{error:addSubAdminForm.controls['phoneNumber'].hasError('required')}">
                                        *Please enter a phone number.
                                    </span>
                                    }
                                    @if(addSubAdminForm.controls['phoneNumber'].hasError('pattern')){
                                    <span style='color:red'
                                        [ngClass]="{error: addSubAdminForm.controls['phoneNumber'].hasError('pattern')}">
                                        *Please enter valid Phone number.
                                    </span>
                                    }
                                </div>
                                }
                            </div>
                        </div>

                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-4">
                                <h6> Password :</h6>
                            </label>
                            <div class="col-md-8">
                                <input type="password" class="form-control" placeholder="Password"
                                    (keypress)="passwordKeyPress($event)" formControlName="Password" maxlength="50">
                            </div>
                        </div>

                        <div class="text-center mt40">
                            <button class="btn btn-theme" [disabled]="addSubAdminForm.invalid"
                                (click)="addPatientApi()">Save</button>
                            <button class="btn btn-danger" style="margin-left: 20px;min-width: 100px;"
                                routerLink="/patient-mgt">Cancel</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</main>